/// <amd-module name="Dashboards/WidgetCatalogUI/CatalogPanel" />
import { DashboardWidgetProps } from "Dashboards/WidgetContracts/Internal/DashboardWidgetProps";
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { CustomPanel } from "VSSUI/Panel";
import { WidgetCatalogView } from "./WidgetCatalogView";

export interface CatalogPanelProps {
    isOpen: boolean;

    projectId: string;

    onDismiss: () => void;

    /**
     * Returns initial Widget Settings to create a widget.
     */
    onAdd: (initialWidgetSettings: DashboardWidgetProps) => void;

    /**
     * Called to check that widget can be dropped from catalog - if true is returned onDrop will be called next
     * Subscriber, for example dashboard, provides a callback so that catalog can check that the drag can be handed off to it.
     * @param x horizontal mouse coordinate
     * @param y vertical mouse coordinate
     */
    isValidDropPoint: (x: number, y: number) => boolean;

    /**
     * Returns initial Widget Settings to create a widget, plus dragging event from the catalog
     * Called when catalog panel is dropping widget on the consumer, specifically dashboard.
     * Dashboard provides callback to this, and receives the widget and drag event.
     */
    onDrop: (initialWidgetSettings: DashboardWidgetProps, e: Event) => void;
}

/** This panel is used to allow a user to choose a widget. */
export class CatalogPanel extends VssComponent<CatalogPanelProps> {
    public render(): JSX.Element | null {
        if (this.props.isOpen) {
            return (
                <CustomPanel
                    className="dashboards-widget-catalog-panel"
                    onDismiss={this.props.onDismiss}
                    modal={false}
                    lightDismiss={false}
                    blurDismiss={false}
                >
                    <WidgetCatalogView
                        onAdd={this.props.onAdd}
                        isValidDropPoint={this.props.isValidDropPoint}
                        onDrop={this.props.onDrop}
                        projectId={this.props.projectId}
                    />
                </CustomPanel>
            );
        }
        return null;
    }
}
